'use client';

import React, { useEffect, useState } from 'react';
import { shuffle } from 'lodash';
import { RotateCw } from 'lucide-react';
import { TestimonialType } from '@/types/testimonial';

export type TestimonialProps = {
  testimonial: TestimonialType;
  onNext?: () => void;
  size?: number;
  small?: boolean;
};

export const Testimonial = ({ testimonial, onNext, size = 120, small }: TestimonialProps) => {
  const hasNext = Boolean(onNext);

  return (
    <div className="flex gap-10 p-8 cursor-pointer max-w-4xl m-auto group" onClick={onNext}>
      <div className="flex sm:flex-row flex-col gap-10">
        {testimonial.image && (
          <div>
            <div className="rounded-full overflow-hidden" style={{ width: size, height: size }}>
              <img src={testimonial.image} alt={'testimonial image'} />
            </div>
          </div>
        )}

        <div className="flex-1">
          <blockquote className="flex flex-col gap-2">
            <p className={small ? 'text-lg' : 'text-xl'}>
              &ldquo;
              {testimonial.content}
              &rdquo;
            </p>
            <footer>
              <cite> — {testimonial.author}</cite>
            </footer>
          </blockquote>
        </div>
      </div>

      {hasNext && (
        <div className="sm:opacity-0 opacity-100 group-hover:opacity-100 transition-all">
          <RotateCw />
        </div>
      )}
    </div>
  );
};

type TestimonialsProps = {
  testimonials: TestimonialType[];
  small?: boolean;
};

export const Testimonials = (props: TestimonialsProps) => {
  const { testimonials: _testimonials, small } = props;
  const [index, setIndex] = useState(0);
  const [testimonials, setTestimonials] = useState<TestimonialType[]>([]);

  const handleNext = () => {
    setIndex((index + 1) % testimonials.length);
  };

  useEffect(() => {
    setTestimonials(shuffle(_testimonials));
    setIndex(Math.floor(Math.random() * _testimonials.length));
  }, []);

  const testimonial = testimonials[index];

  if (!testimonial) {
    return null;
  }

  return (
    <Testimonial
      testimonial={testimonial}
      onNext={testimonials.length > 1 ? handleNext : undefined}
      small={small}
    />
  );
};
